import { Outlet } from 'react-router-dom'

const EV = () => <Outlet />

export default EV
